import { Meta, StoryObj } from '@storybook/react';

import { Paragraph } from './Paragraph';

const meta: Meta<typeof Paragraph> = {
  title: 'parts/text/Paragraph',
  component: Paragraph,
  args: {
    children:
      'この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、',
  },
};

export default meta;

type Story = StoryObj<typeof Paragraph>;

export const Basic: Story = {
  render: args => <Paragraph>{args.children}</Paragraph>,
};
